import UserInterface from '@app/Interface/UserInterface';
import UserRoleTypesInterface from '@app/Interface/UserRoleTypesInterface';
import UserAuthentication from '@app/Security/UserAuthentication';
import * as React from 'react';
import { ReactTabulator } from 'react-tabulator';
import TabulatorCommonOptions from '@app/utils/TabulatorCommonOptions';

import SCTabulator from '@app/utils/SCTabulator';
import options from '@app/utils/SCTabulatorCommonOptions';

interface UserRoleDescriptionsProps {
    user: UserInterface;
    roleTypes: UserRoleTypesInterface[];
}

const UserRoleDescriptions: React.FC<UserRoleDescriptionsProps> = ({ user, roleTypes }) => {

    const [filteredRoleTypes, setFilteredRoleTypes] = React.useState<UserRoleTypesInterface[]>([]);

    // filter the roleTypes available to the user
    React.useEffect(() => {

        // TODO: should we filter out role types based by member status?
        const isUserMember = UserAuthentication.userIsMember(user.viewPermissions);

        /**
         * fpu roles only 
         * ignore master account 
         * members can see member roles
         * non-members can see non-member roles
         */
        const filteredRoles: UserRoleTypesInterface[] = roleTypes.filter(roleType => roleType.roleType === "fpu" && roleType.isMasterAccountRole === false && (!isUserMember === roleType.isNonMemberRole || isUserMember === !roleType.isNonMemberRole));

        setFilteredRoleTypes(filteredRoles);

    }, [user, roleTypes]);

    const tabulatorColumns = [
        { title: "Role", field: "title" },
        { title: "Description", field: "description", formatter: "textarea" },
    ];

    const tabulatorOptions = {
        headerSort: false, //disable header sort for all columns
        
    };

    return (
        <>
            {/* <ReactTabulator
                data={filteredRoleTypes}
                columns={tabulatorColumns}
                options={{...TabulatorCommonOptions, ...tabulatorOptions}}
                layout={"fitColumns"}
            /> */}
            <SCTabulator
                data={filteredRoleTypes}
                columns={tabulatorColumns}
                layout="fitColumns"
                options={{
                    // ...TabulatorCommonOptions, ...tabulatorOptions
                    ...options('nda-user-role-descriptions-sc', false, false), ...tabulatorOptions
                }}
            />
        </>
    );

}

export default UserRoleDescriptions;